export default {"src":"/_next/static/media/ALLY.cef633d5.svg","height":18,"width":18};